import React, {FC} from 'react';
import {Modal} from 'react-bootstrap';
import {ReloadError} from 'components/ReloadError';
import {configs, Inputs} from 'templates/reports/configs';
import {useCache} from 'templates/reports/query';
import {ReportSettings} from 'templates/reports/reportTypes';
import {ReportsCore} from 'templates/reports/StandardCore';

import {ReportSpinner} from './ReportSpinner';

import * as styles from './styles.module.scss';

type ContentProps = ReportSettings & {
	cache: string
}

const Content: FC<ContentProps> = ({cache, ...rest}) => {
	const {data, error, valid} = useCache({cache});
	const settings: ReportSettings = rest;

	if (error) {
		return <ReloadError className={styles.error} />;
	} else if (!data) {
		return <ReportSpinner className={styles.pending} />;
	} else if (!valid) {
		return <ReloadError className={styles.error} />;
	}

	const inputs: Inputs = JSON.parse(data.reports.dexa.inputsJson);
	const cfgs = configs(inputs, data.reports.dexa);

	return (
		<div className={styles.report}>
			<ReportsCore cfgs={cfgs} data={data} {...settings} />
		</div>
	);
};

type ReportModalProps = ReportSettings & {
	children?: React.ReactNode
	cache: string
	onHide: () => void
}

export const ReportModal: FC<ReportModalProps> = (props) => {
	const header = props.children || (
		<Modal.Header closeButton className={styles.header}>
			Your BodySpec report
		</Modal.Header>
	);

	return (
		<Modal scrollable show size='xl'
			dialogClassName={styles.overlay}
			onHide={props.onHide}
		>
			{header}
			<Modal.Body className={styles.body}>
				<Content {...props} />
			</Modal.Body>
		</Modal>
	);
};
